<div class="mb-3">
  <label *ngIf="label" [ngClass]="{'required': required}" [for]="identifier">{{ label }}</label>
  <input [id]="identifier" class="form-control" currencyMask 
         [(ngModel)]="value" name="nome" style="height:36px"
         [options]="_options" [disabled]="disabled" [required]="required"
         [ngClass]="{ 'is-invalid': form && (form.submitted || form.controls[name]?.touched || form.controls[name]?.dirty) && form.controls[name]?.errors}" />

  <validation-errors [form]="form" [controlName]="name"></validation-errors>
</div>
